import { AfterViewInit, Renderer2, ElementRef } from '@angular/core';
var KeywordHighlighterDirective = /** @class */ (function () {
    function KeywordHighlighterDirective(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    Object.defineProperty(KeywordHighlighterDirective.prototype, "keywordList", {
        get: function () {
            return this._keywordList;
        },
        set: function (value) {
            if (value) {
                this._keywordList = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    KeywordHighlighterDirective.prototype.ngAfterViewInit = function () {
        this.highlightKeyword();
    };
    KeywordHighlighterDirective.prototype.highlightKeyword = function () {
        var _this = this;
        this.keywordList.forEach(function (keyword) {
            var matchRegEep = new RegExp(keyword, 'ig');
            _this.renderer.setProperty(_this.elementRef.nativeElement, 'innerHTML', _this.elementRef.nativeElement.innerHTML.replace(matchRegEep, '<span class="highlight">' + keyword + '</span>'));
        });
    };
    return KeywordHighlighterDirective;
}());
export { KeywordHighlighterDirective };
